import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { containerTableCustomStyles, shipmentContainerTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";
import { centeredFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";
import logoInoxShipping from "../../../images/inox_logo.png";
import { format } from "date-fns";
import { downloadPDF } from "../../../utils/downloadPdf";
import DepotIcon from "../../../images/depot_white.png"



function PlannedExportContainer(props) {
  const pickcontainerform = useRef(null);
  const [containerFilters, setContainerFilters] = useState({ container_number: '' });
  const [selectedContainerData, setSelectedContainerData] = useState([]);
  const [emptyContainerData, setEmptyContainerData] = useState([]);
  const [emptyContainerDataPending, setEmptyContainerDataPending] = useState([]);
  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentContainerData, setShipmentContainerData] = useState([]);
  const [shipmentContainerPictureData, setShipmentContainerPictureData] = useState([]);
  const [shipmentCroData, setShipmentCroData] = useState([]);
  const [enablePickContainerButton, setEnablePickContainerButton] = useState(false);

  const [shipmentDataPending, setShipmentDataPending] = useState(true);
  const [shipmentContainerDataPending, setShipmentContainerDataPending] = useState(true);
  const [shipmentContainerPictureDataPending, setShipmentContainerPictureDataPending] = useState(true);

  const shipment_id = props.shipmentId
  const agentList = props.agentList
  const userList = props.userList
  const portList = props.portList
  const terminalList = props.terminalList
  const containerList = props.containerList
  const selectableContainerList = props.selectableContainerList
  const depotList = props.depotList
  const vesselList = props.vesselList
  const operatorList = props.operatorList
  const cargoList = props.cargoList
  const currentUserRolePermissionData = props.currentUserRolePermissionData
  const loggedInUser = props.loggedInUser

  // ----------------------- Container --------------------------------
  const [showShipmentContainerPickModal, setShowShipmentContainerPickModal] = useState(false);
  const [showShipmentContainerUnpickModal, setShowShipmentContainerUnpickModal] = useState(false);
  const [showShipmentContainerVgmWeightModal, setShowShipmentContainerVgmWeightModal] = useState(false);
  const [showShipmentContainerForm13Modal, setShowShipmentContainerForm13Modal] = useState(false);
  const [showShipmentContainerPortInModal, setShowShipmentContainerPortInModal] = useState(false);
  const [showShipmentContainerPortOutModal, setShowShipmentContainerPortOutModal] = useState(false);
  const [showShipmentContainerRevertPortInModal, setShowShipmentContainerRevertPortInModal] = useState(false);
  const [showShipmentContainerCfsInModal, setShowShipmentContainerCfsInModal] = useState(false);
  const [showShipmentContainerCfsOutModal, setShowShipmentContainerCfsOutModal] = useState(false);
  const [showShipmentContainerDepotInModal, setShowShipmentContainerDepotInModal] = useState(false);
  const [showShipmentContainerBeforeStuffingModal, setShowShipmentContainerBeforeStuffingModal] = useState(false);
  const [showShipmentContainerAfterStuffingModal, setShowShipmentContainerAfterStuffingModal] = useState(false);
  const [showShipmentContainerBeforeDestuffingModal, setShowShipmentContainerBeforeDestuffingModal] = useState(false);
  const [showShipmentContainerAfterDestuffingModal, setShowShipmentContainerAfterDestuffingModal] = useState(false);
  const [showShipmentContainerPicsModal, setShowShipmentContainerPicsModal] = useState(false);

  const [shipmentContainer, setShipmentContainer] = useState([]);
  const [shipmentContainerPickupLoader, setShipmentContainerPickupLoader] = useState(false);
  const [shipmentContainerUnpickupLoader, setShipmentContainerUnpickupLoader] = useState(false);
  const [shipmentContainerVgmWeightLoader, setShipmentContainerVgmWeightLoader] = useState(false);
  const [shipmentContainerForm13Loader, setShipmentContainerForm13Loader] = useState(false);
  const [shipmentContainerPortInLoader, setShipmentContainerPortInLoader] = useState(false);
  const [shipmentContainerPortOutLoader, setShipmentContainerPortOutLoader] = useState(false);
  const [shipmentContainerRevertPortInLoader, setShipmentContainerRevertPortInLoader] = useState(false);
  const [shipmentContainerCfsInLoader, setShipmentContainerCfsInLoader] = useState(false);
  const [shipmentContainerCfsOutLoader, setShipmentContainerCfsOutLoader] = useState(false);
  const [shipmentContainerDepotInLoader, setShipmentContainerDepotInLoader] = useState(false);
  const [shipmentContainerBeforeStuffingLoader, setShipmentContainerBeforeStuffingLoader] = useState(false);
  const [shipmentContainerAfterStuffingLoader, setShipmentContainerAfterStuffingLoader] = useState(false);
  const [shipmentContainerBeforeDestuffingLoader, setShipmentContainerBeforeDestuffingLoader] = useState(false);
  const [shipmentContainerAfterDestuffingLoader, setShipmentContainerAfterDestuffingLoader] = useState(false);

  const [shipmentContainerPickupDate, setShipmentContainerPickupDate] = useState(null);
  const [shipmentContainerAgainstCro, setShipmentContainerAgainstCro] = useState(null);
  const [shipmentContainerVgmWeight, setShipmentContainerVgmWeight] = useState(0);
  const [shipmentContainerForm13Date, setShipmentContainerForm13Date] = useState(null);
  const [shipmentContainerPortInDate, setShipmentContainerPortInDate] = useState(null);
  const [shipmentContainerPortOutDate, setShipmentContainerPortOutDate] = useState(null);
  const [shipmentContainerCfsInDate, setShipmentContainerCfsInDate] = useState(null);
  const [shipmentContainerCfsOutDate, setShipmentContainerCfsOutDate] = useState(null);
  const [shipmentContainerDepotInDate, setShipmentContainerDepotInDate] = useState(null);
  const [shipmentContainerPicturesBeforeStuffing, setShipmentContainerPicturesBeforeStuffing] = useState(null);
  const [shipmentContainerPicturesAfterStuffing, setShipmentContainerPicturesAfterStuffing] = useState(null);
  const [shipmentContainerPicturesBeforeDestuffing, setShipmentContainerPicturesBeforeDestuffing] = useState(null);
  const [shipmentContainerPicturesAfterDestuffing, setShipmentContainerPicturesAfterDestuffing] = useState(null);

  const [shipmentContainerPicturesBeforeStuffingPreview, setShipmentContainerPicturesBeforeStuffingPreview] = useState(null);
  const [shipmentContainerPicturesAfterStuffingPreview, setShipmentContainerPicturesAfterStuffingPreview] = useState(null);
  const [shipmentContainerPicturesBeforeDestuffingPreview, setShipmentContainerPicturesBeforeDestuffingPreview] = useState(null);
  const [shipmentContainerPicturesAfterDestuffingPreview, setShipmentContainerPicturesAfterDestuffingPreview] = useState(null);
  
  

  const getShipment = async (shipment_id) => {
    setShipmentDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/' + shipment_id);
      if (response) {
        setShipmentData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
    setShipmentDataPending(false)
  }

  const getEmptyContainer = async (shipment_container_id) => {
    setEmptyContainerDataPending(true)
    try {
      const cro_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro?shipment_container='+shipment_container_id+'&status=ISSUED');
      const data = cro_response.data

      // const containers_from_depot_list = data.map(item => ({ containers_from_depot: item.containers_from_depot, }));

      // const container_list =  encodeURIComponent(JSON.stringify(containers_from_depot_list?.[0]?.['containers_from_depot']))

      const containers_from_depot_list = data.flatMap(item => item.containers_from_depot || []);

      const container_list = encodeURIComponent(JSON.stringify(containers_from_depot_list));


      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container?status=EMPTY_AV&containers_from_depot_list='+container_list);
      if (response) {
        setEmptyContainerData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching empty container data! Try again.");
    }
    setEmptyContainerDataPending(false)
  }

  const getShipmentContainer = async (shipment_id) => {
    setShipmentContainerDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer?shipment=' + shipment_id);
      if (response) {
        setShipmentContainerData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment container data! Try again.");
    }
    setShipmentContainerDataPending(false)
  }

  const getShipmentContainerPicture = async (shipment_container_id) => {
    setShipmentContainerPictureDataPending(true)
    try {
      if(shipment_container_id){
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainerpicture?shipment_container=' + shipment_container_id);
        if (response) {
          setShipmentContainerPictureData(response.data)
        }
      }
    } catch (err) {
      toast.error("Error in fetching shipment container picture data! Try again.");
    }
    setShipmentContainerPictureDataPending(false)
  }

  const getShipmentCro = async (shipment_container_id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcro?shipment_container='+shipment_container_id+'&status=ISSUED');
      if (response) {
        const data = response.data
        const cro_list = data.map(item => ({ value: item.id, label: item.do_number + " Version: " + item.version + " (" + format(new Date(item.validity), "dd-MM-yyyy") + ")", }));
        setShipmentCroData(cro_list)
      }
    } catch (err) {
      toast.error("Error in fetching shipment cro data! Try again.");
    }
  }

  useEffect(() => {
    getShipment(shipment_id)
    getShipmentContainer(shipment_id)
    getShipmentCro(shipment_id)
  }, [shipment_id]);

  const handleFilterChange = (column, value) => {
    setContainerFilters(prev => ({ ...prev, [column]: value }));
  };

  const filteredData = emptyContainerData.filter(item =>
    Object.keys(containerFilters).every(key => item[key]?.toLowerCase().includes(containerFilters[key].toLowerCase()))
  );

  const containercolumns = [
    {
      name: (
        <div class="form-group">
          <label>Container No.</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('container_number', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row =>
        <div className={`${row.declaration_type == "SALE_UNIT" ? "text-danger fw-bold" : ""}`}>
          {row.container_number}          
        </div>,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Type</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('type', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.type == "HD20" ? "20HD" : 
                      row.type == "HD40" ? "40HD" :
                      row.type == "GP20" ? "20GP" :
                      row.type == "GP40" ? "40GP" :
                      "40HQ",
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Grade</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('grade', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.grade,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Location</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('current_location__name', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.current_location__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Depot</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('current_depot__name', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.current_depot__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Agent</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('current_agent__name', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.current_agent__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Owner</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('owner__name', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.owner__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Status</label>
          <input className="form form-control form-control-sm my-1" onChange={e => handleFilterChange('status', e.target.value)} style={{ width: '100px'}}/>
        </div>
      ),
      selector: row => row.status,
      sortable: true,
    }
  ];


  const shipmentcontainercolumns = [
    {
      name: 'Container No.',
      width: '140px',
      selector: row => row.container?.container_number,
      sortable: true,
    },
    {
      name: 'Type',
      width: '80px',
      selector: row => row.container?.type,
      sortable: true,
    },
    {
      name: 'Pick Depot',
      selector: row => row.pick_depot_data?.name,
      sortable: true,
    },
    {
      name: 'Against CRO',
      width: '200px',
      selector: row => row.against_cro_data?.do_number,
      sortable: true,
    },
    {
      name: 'Pick Date',
      width: '100px',
      selector: row =>  row.pick_date ? format(new Date(row.pick_date), 'dd-MM-yyyy') : "-",
      sortable: true,
    },
    {
      name: 'VGM Weight',
      width: '120px',
      selector: row => row.vgm_weight > 0? row.vgm_weight + " KG": "-",
      sortable: true,
    },
    {
      name: 'Date',
      width: '200px',
      selector: row => <>
        <span><b>Form 13 Date: </b> {row.form_13_date ? format(new Date(row.form_13_date), 'dd-MM-yyyy') : "-"}</span><br></br>
        <span><b>Port In Date: </b> {row.port_in_date ? format(new Date(row.port_in_date), 'dd-MM-yyyy') : "-"}</span><br></br>
        <span><b>Port Out Date: </b> {row.port_out_date ? format(new Date(row.port_out_date), 'dd-MM-yyyy') : "-"}</span><br></br>
        <span><b>CFS In Date: </b> {row.cfs_in_date ? format(new Date(row.cfs_in_date), 'dd-MM-yyyy') : "-"}</span><br></br>
        <span><b>CFS Out Date: </b> {row.cfs_out_date ? format(new Date(row.cfs_out_date), 'dd-MM-yyyy') : "-"}</span><br></br>
        <span><b>Depot In Date: </b> {row.depot_in_date ? format(new Date(row.depot_in_date), 'dd-MM-yyyy') : "-"}</span><br></br>
      </>,
      sortable: true,
    },
    {
      name: 'IDLED',
      width: '90px',
      selector: row => row.idled,
      sortable: true,
    },
    {
      name: 'Container Action',
      width: '150px',
      center: true,
      selector: row =>
        <div>
          <p>
          {
            currentUserRolePermissionData?.includes("shipment:containerunpick:view") ?
              <Button className="btn btn-sm btn-inox-red border-0 my-1 mr-1" style={{ height: 30 }} title="Unpick" onClick={() => handleShowShipmentContainerUnpickModal(row)}>
                <i className="fa fa-times"></i>
              </Button>
              :
              ""
          }
          
          {
            currentUserRolePermissionData?.includes("shipment:containervgmweight:view") ?
              <Button className="btn btn-sm btn-inox-primary border-0 my-1 mr-1" style={{ height: 30 }} title="VGM Weight" onClick={() => handleShowShipmentContainerVgmWeightModal(row)}>
                <i className="fa fa-balance-scale"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:containerform13:view") ?
              <Button className="btn btn-sm btn-warning border-0 my-1 mr-1" style={{ height: 30 }} title="Form 13" onClick={() => handleShowShipmentContainerForm13Modal(row)}>
                <i className="fa fa-file-text-o"></i>
              </Button>
              :
              ""
          }
          </p>
        </div>,
    },
    {
      name: 'Port Action',
      width: '100px',
      center: true,
      selector: row =>
        <div>
          <p>
          {
            currentUserRolePermissionData?.includes("shipment:containerportin:view") && !row.port_in_date ?
              <Button className="btn btn-sm btn-success border-0 my-1 mr-1" style={{ height: 30 }} title="Port In" onClick={() => handleShowShipmentContainerPortInModal(row)}>
                <i className="fa fa-arrow-circle-down"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:containerportout:view") && row.port_in_date ?
              <Button className="btn btn-sm btn-info border-0 my-1 mr-1" style={{ height: 30 }} title="Port Out" onClick={() => handleShowShipmentContainerPortOutModal(row)}>
                <i className="fa fa-arrow-circle-up"></i>
              </Button>
              :
              ""
          }
          
          {
            currentUserRolePermissionData?.includes("shipment:containerrevertportin:view") && row.port_in_date ?
              <Button className="btn btn-sm btn-danger border-0 my-1 mr-1" style={{ height: 30 }} title="Revert Port In" onClick={() => handleShowShipmentContainerRevertPortInModal(row)}>
                <i className="fa fa-ban"></i>
              </Button>
              :
              ""
          }
          </p>
        </div>,
    },
    {
      name: 'CFS Action',
      width: '100px',
      center: true,
      selector: row =>
        <div>
          <p>
          {
            currentUserRolePermissionData?.includes("shipment:containercfsin:view") && !row.cfs_in_date?
              <Button className="btn btn-sm btn-success border-0 my-1 mr-1" style={{ height: 30 }} title="CFS In" onClick={() => handleShowShipmentContainerCfsInModal(row)}>
                <img src={DepotIcon} height={15} width={15} />
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:containercfsout:view") && row.cfs_in_date ?
              <Button className="btn btn-sm btn-info border-0 my-1 mr-1" style={{ height: 30 }} title="CFS Out" onClick={() => handleShowShipmentContainerCfsOutModal(row)}>
                <img src={DepotIcon} height={15} width={15} />
              </Button>
              :
              ""
          }
          </p>
        </div>,
    },
    {
      name: 'Stuffing Action',
      width: '150px',
      center: true,
      selector: row =>
        <div>
          <p>
          {
            currentUserRolePermissionData?.includes("shipment:containerbeforestuffing:view") ?
              <Button className="btn btn-sm btn-secondary border-0 my-1 mr-1" style={{ height: 30 }} title="Upload Before Stuffing" onClick={() => handleShowShipmentContainerBeforeStuffingModal(row)}>
                <i className="fa fa-th"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:containerafterstuffing:view") ?
              <Button className="btn btn-sm btn-primary border-0 my-1 mr-1" style={{ height: 30 }} title="Upload After Stuffing" onClick={() => handleShowShipmentContainerAfterStuffingModal(row)}>
                <i className="fa fa-truck"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:containerpics:view") ?
              <Button className="btn btn-sm btn-info border-0 my-1" style={{ height: 30 }} title="View Pics" onClick={() => handleShowShipmentContainerPicsModal(row)}>
                <i className="fa fa-file-image-o"></i>
              </Button>
              :
              ""
          }
          </p>
        </div>,
    }
  ];

  const handleShowShipmentContainerPickModal = () => {
    getEmptyContainer(shipment_id)
    setShowShipmentContainerPickModal(true)
  }

  const handleShowShipmentContainerUnpickModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerUnpickModal(true)
  }

  const handleCloseShipmentContainerUnpickModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerUnpickModal(false)
  }

  const handleShowShipmentContainerVgmWeightModal = (data) => {
    setShipmentContainer(data)
    setShipmentContainerVgmWeight(data?.vgm_weight)
    setShowShipmentContainerVgmWeightModal(true)
  }

  const handleCloseShipmentContainerVgmWeightModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerVgmWeightModal(false)
  }

  const handleShowShipmentContainerForm13Modal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerForm13Modal(true)
  }

  const handleCloseShipmentContainerForm13Modal = () => {
    setShipmentContainer("")
    setShowShipmentContainerForm13Modal(false)
  }

  const handleShowShipmentContainerPortInModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerPortInModal(true)
  }

  const handleCloseShipmentContainerPortInModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerPortInModal(false)
  }

  const handleShowShipmentContainerPortOutModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerPortOutModal(true)
  }

  const handleCloseShipmentContainerPortOutModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerPortOutModal(false)
  }

  const handleShowShipmentContainerRevertPortInModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerRevertPortInModal(true)
  }

  const handleCloseShipmentContainerRevertPortInModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerRevertPortInModal(false)
  }

  const handleShowShipmentContainerCfsInModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerCfsInModal(true)
  }

  const handleCloseShipmentContainerCfsInModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerCfsInModal(false)
  }

  const handleShowShipmentContainerCfsOutModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerCfsOutModal(true)
  }

  const handleCloseShipmentContainerCfsOutModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerCfsOutModal(false)
  }

  const handleShowShipmentContainerDepotInModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerDepotInModal(true)
  }

  const handleCloseShipmentContainerDepotInModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerDepotInModal(false)
  }

  const handleShowShipmentContainerBeforeStuffingModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerBeforeStuffingModal(true)
  }

  const handleCloseShipmentContainerBeforeStuffingModal = () => {
    setShipmentContainer("")
    setShipmentContainerPicturesBeforeStuffingPreview(null)
    setShowShipmentContainerBeforeStuffingModal(false)
  }

  const handleShowShipmentContainerAfterStuffingModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerAfterStuffingModal(true)
  }

  const handleCloseShipmentContainerAfterStuffingModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerAfterStuffingModal(false)
  }

  const handleShowShipmentContainerBeforeDestuffingModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerBeforeDestuffingModal(true)
  }

  const handleCloseShipmentContainerBeforeDestuffingModal = () => {
    setShipmentContainer("")
    setShipmentContainerPicturesBeforeDestuffingPreview(null)
    setShowShipmentContainerBeforeDestuffingModal(false)
  }

  const handleShowShipmentContainerAfterDestuffingModal = (data) => {
    setShipmentContainer(data)
    setShowShipmentContainerAfterDestuffingModal(true)
  }

  const handleCloseShipmentContainerAfterDestuffingModal = () => {
    setShipmentContainer("")
    setShowShipmentContainerAfterDestuffingModal(false)
  }

  const handleShowShipmentContainerPicsModal = (data) => {
    setShipmentContainer(data)
    getShipmentContainerPicture(data?.id)
    setShowShipmentContainerPicsModal(true)
  }

  const handleCloseShipmentContainerPicsModal = () => {
    setShipmentContainer("")
    setShipmentContainerPictureData([])
    setShowShipmentContainerPicsModal(false)
  }

  const pickupContainer = async (e) => {
    e.preventDefault();
    setShipmentContainerPickupLoader(true)

    const data = {
      "shipment": shipment_id,
      "shipment_container": selectedContainerData,
      "pick_date": shipmentContainerPickupDate,
      "against_cro": shipmentContainerAgainstCro,
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/pickupcontainer/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container Picked successfully");
        getShipmentContainer(shipment_id)
        setSelectedContainerData([])
        setShipmentContainerPickupDate(null)
        setShipmentContainerAgainstCro(null)
      }
    } catch (err) {
      toast.error("Error in picking up containers! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerPickModal(false)
    setShipmentContainerPickupLoader(false)
  }

  const  unpickupContainer = async (e) => {
    e.preventDefault();
    setShowShipmentContainerUnpickModal(true)

    const id = shipmentContainer?.id
    const container_id = shipmentContainer?.container?.id

    const data = {
      "id": id,
      "container_id": container_id
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/unpickupcontainer/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("Container removed successfully");
        getShipmentContainer(shipment_id)
        getEmptyContainer(shipment_id)
      }
    } catch (err) {
      toast.error("Error in unpicking container! Try again.");
    }

    getShipmentContainer(shipment_id)
    getEmptyContainer(shipment_id)
    setShowShipmentContainerUnpickModal(false)
    setShipmentContainerUnpickupLoader(false)
  }

  const  vgmContainerWeight = async (e) => {
    e.preventDefault();
    setShowShipmentContainerVgmWeightModal(true)

    const id = shipmentContainer?.id

    const data = {
      "vgm_weight": shipmentContainerVgmWeight,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container VGM weight added successfully");
        getShipmentContainer(shipment_id)
      }
    } catch (err) {
      toast.error("Error in adding container vgm weight! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerVgmWeightModal(false)
    setShipmentContainerVgmWeightLoader(false)
  }

  const containerForm13Date = async (e) => {
    e.preventDefault();
    setShowShipmentContainerForm13Modal(true)
    setShipmentContainerForm13Loader(true)

    const id = shipmentContainer?.id

    const data = {
      "form_13_date": shipmentContainerForm13Date,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container form 13 date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerForm13Date(null)
      }
    } catch (err) {
      toast.error("Error in adding form 13 date! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerForm13Modal(false)
    setShipmentContainerForm13Loader(false)
  }

  const  containerPortIn = async (e) => {
    e.preventDefault();
    setShipmentContainerPortInLoader(true)
    setShowShipmentContainerPortInModal(true)

    const id = shipmentContainer?.id

    const data = {
      "port_in_date": shipmentContainerPortInDate,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container port in date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerPortInDate(null)
      }
    } catch (err) {
      toast.error("Error in adding container port in! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerPortInModal(false)
    setShipmentContainerPortInLoader(false)
  }

  const  containerPortOut = async (e) => {
    e.preventDefault();
    setShipmentContainerPortOutLoader(true)
    setShowShipmentContainerPortOutModal(true)

    const id = shipmentContainer?.id

    const data = {
      "port_out_date": shipmentContainerPortOutDate,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container port out date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerPortOutDate(null)
      }
    } catch (err) {
      toast.error("Error in adding container port out! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerPortOutModal(false)
    setShipmentContainerPortOutLoader(false)
  }

  const  containerRevertPortIn = async (e) => {
    e.preventDefault();
    setShipmentContainerRevertPortInLoader(true)
    setShowShipmentContainerRevertPortInModal(true)

    const id = shipmentContainer?.id

    const data = {
      "port_in_date": null,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container port in date removed successfully");
        getShipmentContainer(shipment_id)
      }
    } catch (err) {
      toast.error("Error in removing container port in! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerRevertPortInModal(false)
    setShipmentContainerRevertPortInLoader(false)
  }

  const  containerCfsIn = async (e) => {
    e.preventDefault();
    setShipmentContainerCfsInLoader(true)
    setShowShipmentContainerCfsInModal(true)

    const id = shipmentContainer?.id

    const data = {
      "cfs_in_date": shipmentContainerCfsInDate,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container cfs in date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerCfsInDate(null)
      }
    } catch (err) {
      toast.error("Error in adding container cfs in! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerCfsInModal(false)
    setShipmentContainerCfsInLoader(false)
  }

  const  containerCfsOut = async (e) => {
    e.preventDefault();
    setShipmentContainerCfsOutLoader(true)
    setShowShipmentContainerCfsOutModal(true)

    const id = shipmentContainer?.id

    const data = {
      "cfs_out_date": shipmentContainerCfsOutDate,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container cfs in date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerCfsOutDate(null)
      }
    } catch (err) {
      toast.error("Error in adding container cfs in! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerCfsOutModal(false)
    setShipmentContainerCfsOutLoader(false)
  }

  const  containerDepotIn = async (e) => {
    e.preventDefault();
    setShipmentContainerDepotInLoader(true)
    setShowShipmentContainerDepotInModal(true)

    const id = shipmentContainer?.id

    const data = {
      "depot_in_date": shipmentContainerDepotInDate,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Container depot in date added successfully");
        getShipmentContainer(shipment_id)
        setShipmentContainerDepotInDate(null)
      }
    } catch (err) {
      toast.error("Error in adding container depot in! Try again.");
    }

    getShipmentContainer(shipment_id)
    setShowShipmentContainerDepotInModal(false)
    setShipmentContainerDepotInLoader(false)
  }

  // -------------------------------- Before Stuffing ---------------------------------------------
  const containerBeforeStuffing = async (e) => {
    e.preventDefault();
    setShowShipmentContainerBeforeStuffingModal(true)

    const shipment_container_id = shipmentContainer?.id

    const data = {
      "shipment_container": shipment_container_id,
      "picture": shipmentContainerPicturesBeforeStuffing,
      "picture_category": "BEFORE_STUFFING",
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainerpicture/addcontainerbeforestuffingpicture/', data, { headers: { "Content-Type": "multipart/form-data" } });

      if (response.status == 200) {
        toast.success("Container pictures before stuffing added successfully");
      }
    } catch (err) {
      toast.error("Error in uploding container pictures! Try again.");
    }

    getShipmentContainer(shipment_id)
    getShipmentContainerPicture(shipment_container_id)
    setShipmentContainerPicturesBeforeStuffingPreview(null)
    setShowShipmentContainerBeforeStuffingModal(false)
    setShipmentContainerBeforeStuffingLoader(false)
  }

  const handleBeforeStuffingChange = (e) => {
    const files = Array.from(e.target.files);

    setShipmentContainerPicturesBeforeStuffing(files);

    const previews = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    setShipmentContainerPicturesBeforeStuffingPreview(previews);
  };

  // -------------------------------- After Stuffing ---------------------------------------------
  const containerAfterStuffing = async (e) => {
    e.preventDefault();
    setShowShipmentContainerAfterStuffingModal(true)

    const shipment_container_id = shipmentContainer?.id

    const data = {
      "shipment_container": shipment_container_id,
      "picture": shipmentContainerPicturesAfterStuffing,
      "picture_category": "AFTER_STUFFING",
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainerpicture/addcontainerafterstuffingpicture/', data, { headers: { "Content-Type": "multipart/form-data" } });

      if (response.status == 200) {
        toast.success("Container pictures after stuffing added successfully");
      }
    } catch (err) {
      toast.error("Error in uploding container pictures! Try again.");
    }

    getShipmentContainer(shipment_id)
    getShipmentContainerPicture(shipment_container_id)
    setShipmentContainerPicturesAfterStuffingPreview(null)
    setShowShipmentContainerAfterStuffingModal(false)
    setShipmentContainerAfterStuffingLoader(false)
  }

  const handleAfterStuffingChange = (e) => {
    const files = Array.from(e.target.files);

    setShipmentContainerPicturesAfterStuffing(files);

    const previews = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    setShipmentContainerPicturesAfterStuffingPreview(previews);
  };

  // -------------------------------- Before De-Stuffing ---------------------------------------------
  const  containerBeforeDestuffing = async (e) => {
    e.preventDefault();
    setShowShipmentContainerBeforeDestuffingModal(true)

    const shipment_container_id = shipmentContainer?.id

    const data = {
      "shipment_container": shipment_container_id,
      "picture": shipmentContainerPicturesBeforeDestuffing,
      "picture_category": "BEFORE_DESTUFFING",
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainerpicture/addcontainerbeforedestuffingpicture/', data, { headers: { "Content-Type": "multipart/form-data" } });

      if (response.status == 200) {
        toast.success("Container pictures before destuffing added successfully");
      }
    } catch (err) {
      toast.error("Error in uploding container pictures! Try again.");
    }

    getShipmentContainer(shipment_id)
    getShipmentContainerPicture(shipment_container_id)
    setShipmentContainerPicturesBeforeDestuffingPreview(null)
    setShowShipmentContainerBeforeDestuffingModal(false)
    setShipmentContainerBeforeDestuffingLoader(false)
  }

  const handleBeforeDestuffingChange = (e) => {
    const files = Array.from(e.target.files);

    setShipmentContainerPicturesBeforeDestuffing(files);

    const previews = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    setShipmentContainerPicturesBeforeDestuffingPreview(previews);
  };

  // -------------------------------- After De-Stuffing ---------------------------------------------
  const  containerAfterDestuffing = async (e) => {
    e.preventDefault();
    setShowShipmentContainerAfterDestuffingModal(true)

    const shipment_container_id = shipmentContainer?.id

    const data = {
      "shipment_container": shipment_container_id,
      "picture": shipmentContainerPicturesAfterDestuffing,
      "picture_category": "AFTER_DESTUFFING",
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainerpicture/addcontainerbeforedestuffingpicture/', data, { headers: { "Content-Type": "multipart/form-data" } });

      if (response.status == 200) {
        toast.success("Container pictures before destuffing added successfully");
      }
    } catch (err) {
      toast.error("Error in uploding container pictures! Try again.");
    }

    getShipmentContainer(shipment_id)
    getShipmentContainerPicture(shipment_container_id)
    setShipmentContainerPicturesAfterDestuffingPreview(null)
    setShowShipmentContainerAfterDestuffingModal(false)
    setShipmentContainerAfterDestuffingLoader(false)
  }

  const handleAfterDestuffingChange = (e) => {
    const files = Array.from(e.target.files);

    setShipmentContainerPicturesAfterDestuffing(files);

    const previews = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    setShipmentContainerPicturesAfterDestuffingPreview(previews);
  };

  useEffect(() => {
    if (selectedContainerData.length > 0 && shipmentContainerPickupDate && shipmentContainerAgainstCro) {
        setEnablePickContainerButton(true)
      }
      else {
        setEnablePickContainerButton(false)
      }
    }, [selectedContainerData, shipmentContainerPickupDate, shipmentContainerAgainstCro]
  )

  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        {
          currentUserRolePermissionData?.includes("shipment:containerpick:view") ?
          <div className="row">
            <div className="col-12">
              <Button className="btn btn-inox-green border-0" onClick={() => handleShowShipmentContainerPickModal()}>Pick Containers</Button>
            </div>
          </div>
          :
          ""
        }

        <DataTable
          columns={shipmentcontainercolumns}
          data={shipmentContainerData}
          progressPending={shipmentContainerDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center" style={{ marginTop: 150, marginBottom: 150 }}>No Container Found</p>}
          highlightOnHover
          customStyles={shipmentContainerTableCustomStyles}
          dense
        />
      </div>

      {/*  --------------------------- Pick Container --------------------------- */}
      <Modal style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerPickModal} onHide={() => setShowShipmentContainerPickModal(false)} centered fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>Pick Container</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                {filteredData.length<1?
                  <span className="text-inox-green mx-3 pointer" style={{ verticalAlign: 'middle' }} onClick={() => setContainerFilters("","")}>
                    Clear Filters
                  </span>
                  :""
                }

                <DataTable
                  columns={containercolumns}
                  data={filteredData}
                  progressPending={emptyContainerDataPending}
                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                  noDataComponent={<p className="text-center" style={{ marginTop: 150, marginBottom: 150 }}>No Container Found</p>}
                  highlightOnHover
                  customStyles={containerTableCustomStyles}
                  selectableRows
                  onSelectedRowsChange={(e) => setSelectedContainerData(e.selectedRows)}
                  dense
                />
              </div>
              <div className="col-12 text-center mt-4">
                <div class="d-flex justify-content-center">
                  <div class="form-group">
                    <label for="pickup_date" class="col-12 font-12px text-left mb-2">Pickup Date</label>
                    <input type="date" className="form-control" name="pickup_date" id="pickup_date" style={{ width: '400px', marginRight: 10 }} onChange={(e) => setShipmentContainerPickupDate(e.target.value)}/>
                  </div>
                  
                  <div class="form-group">
                    <label for="pickup_date" class="col-12 font-12px text-left mb-2">Shipment CRO</label>
                    <Select
                      options={shipmentCroData}
                      id="against_cro"
                      name="against_cro"
                      onChange={(e) => setShipmentContainerAgainstCro(e)}
                      isMulti={false}
                      isClearable
                      className="px-0"
                      placeholder="Select Cro"
                      value={shipmentContainerAgainstCro}
                      styles={centeredFormSelectCustomStyles}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowShipmentContainerPickModal(false)}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => pickupContainer(e)}
                disabled={enablePickContainerButton?false:true}>
                {shipmentContainerPickupLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Pick Up"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Unpick Container --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerUnpickModal} onHide={() => handleCloseShipmentContainerUnpickModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Unpick Container</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to unpick this container?
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerUnpickModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => unpickupContainer(e)}>
                {shipmentContainerUnpickupLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Unpick"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- VGM Weight Container --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerVgmWeightModal} onHide={() => handleCloseShipmentContainerVgmWeightModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container VGM Weight</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="vgm_weight" class="col-12 font-12px text-left mb-2">VGM Weight (in kg)</label>
              <input type="number" 
                  className="form-control" 
                  name="vgm_weight" 
                  id="vgm_weight" 
                  min={1} 
                  defaultValue={1} 
                  onChange={(e) => setShipmentContainerVgmWeight(e.target.value)}
                  value={shipmentContainerVgmWeight}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerVgmWeightModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => vgmContainerWeight(e)}>
                {shipmentContainerVgmWeightLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>


      {/*  --------------------------- Container Form 13 Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerForm13Modal} onHide={() => handleCloseShipmentContainerForm13Modal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Form 13 Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="form_13" class="col-12 font-12px text-left mb-2">Container Form 13</label>
              <input type="date" 
                  className="form-control" 
                  name="form_13" 
                  id="form_13"
                  onChange={(e) => setShipmentContainerForm13Date(e.target.value)}
                  value={shipmentContainerForm13Date}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerForm13Modal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerForm13Date(e)}>
                {shipmentContainerForm13Loader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>


      {/*  --------------------------- Container Port In Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerPortInModal} onHide={() => handleCloseShipmentContainerPortInModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Port In Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="port_in" class="col-12 font-12px text-left mb-2">Container Port In</label>
              <input type="date" 
                  className="form-control" 
                  name="port_in" 
                  id="port_in"
                  onChange={(e) => setShipmentContainerPortInDate(e.target.value)}
                  value={shipmentContainerPortInDate}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerPortInModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerPortIn(e)}>
                {shipmentContainerPortInLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Container Port Out Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerPortOutModal} onHide={() => handleCloseShipmentContainerPortOutModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Port Out Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="port_out" class="col-12 font-12px text-left mb-2">Container Port Out</label>
              <input type="date" 
                  className="form-control" 
                  name="port_out" 
                  id="port_out"
                  onChange={(e) => setShipmentContainerPortOutDate(e.target.value)}
                  value={shipmentContainerPortOutDate}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerPortOutModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerPortOut(e)}>
                {shipmentContainerPortOutLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Container Revert Port In  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerRevertPortInModal} onHide={() => handleCloseShipmentContainerRevertPortInModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Revert Port In</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              Are you sure you want to revert port in?
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerRevertPortInModal()}>No</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerRevertPortIn(e)}>
                {shipmentContainerRevertPortInLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Yes"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Container CFS In Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerCfsInModal} onHide={() => handleCloseShipmentContainerCfsInModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Cfs In Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="port_in" class="col-12 font-12px text-left mb-2">Container Cfs In</label>
              <input type="date" 
                  className="form-control" 
                  name="port_in" 
                  id="port_in"
                  onChange={(e) => setShipmentContainerCfsInDate(e.target.value)}
                  value={shipmentContainerCfsInDate}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerCfsInModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerCfsIn(e)}>
                {shipmentContainerCfsInLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Container Cfs Out Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerCfsOutModal} onHide={() => handleCloseShipmentContainerCfsOutModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Cfs Out Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="port_out" class="col-12 font-12px text-left mb-2">Container Cfs Out</label>
              <input type="date" 
                  className="form-control" 
                  name="port_out" 
                  id="port_out"
                  onChange={(e) => setShipmentContainerCfsOutDate(e.target.value)}
                  value={shipmentContainerCfsOutDate}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerCfsOutModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerCfsOut(e)}>
                {shipmentContainerCfsOutLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Container Depot In Date  --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerDepotInModal} onHide={() => handleCloseShipmentContainerDepotInModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Depot In Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="port_in" class="col-12 font-12px text-left mb-2">Container Depot In</label>
              <input type="date" 
                  className="form-control" 
                  name="port_in" 
                  id="port_in"
                  onChange={(e) => setShipmentContainerDepotInDate(e.target.value)}
                  value={shipmentContainerDepotInDate}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerDepotInModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerDepotIn(e)}>
                {shipmentContainerDepotInLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Save"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Upload Container Pics Before Stuffing --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerBeforeStuffingModal} onHide={() => handleCloseShipmentContainerBeforeStuffingModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Container Pictures Before Stuffing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="before_stuffing_pictures" class="col-12 font-12px text-left mb-2">Upload Pictures</label>
              <input type="file" 
                    className="form-control" 
                    name="before_stuffing_pictures" 
                    id="before_stuffing_pictures"
                     accept="image/jpeg,image/jpg,image/png"
                    onChange={(e) => [setShipmentContainerPicturesBeforeStuffing(e.target.files), handleBeforeStuffingChange(e)]} 
                    multiple
              />
            </div>

            <div className="row">
              {shipmentContainerPicturesBeforeStuffingPreview?.map((item, index) => (
                <div className="col-6 mt-3" key={index}>
                  <img
                    src={item.preview}
                    alt="preview"
                    className="img-fluid rounded border"
                    style={{ height: 150, objectFit: "cover", width: "100%" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerBeforeStuffingModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerBeforeStuffing(e)}>
                {shipmentContainerBeforeStuffingLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Upload"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Upload Container Pics After Stuffing --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerAfterStuffingModal} onHide={() => handleCloseShipmentContainerAfterStuffingModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Container Pictures After Stuffing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="after_stuffing_pictures" class="col-12 font-12px text-left mb-2">Upload Pictures</label>
              <input type="file" 
                    className="form-control" 
                    name="after_stuffing_pictures" 
                    id="after_stuffing_pictures"
                     accept="image/jpeg,image/jpg,image/png"
                    onChange={(e) => [setShipmentContainerPicturesAfterStuffing(e.target.files), handleAfterStuffingChange(e)]} 
                    multiple
              />
            </div>

            <div className="row">
              {shipmentContainerPicturesAfterStuffingPreview?.map((item, index) => (
                <div className="col-6 mt-3" key={index}>
                  <img
                    src={item.preview}
                    alt="preview"
                    className="img-fluid rounded border"
                    style={{ height: 150, objectFit: "cover", width: "100%" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerAfterStuffingModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerAfterStuffing(e)}>
                {shipmentContainerAfterStuffingLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Upload"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>


      {/*  --------------------------- Upload Container Pics Before De-Stuffing --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerBeforeDestuffingModal} onHide={() => handleCloseShipmentContainerBeforeDestuffingModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Container Pictures Before De-Stuffing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="before_stuffing_pictures" class="col-12 font-12px text-left mb-2">Upload Pictures</label>
              <input type="file" 
                    className="form-control" 
                    name="before_stuffing_pictures" 
                    id="before_stuffing_pictures"
                     accept="image/jpeg,image/jpg,image/png"
                    onChange={(e) => [setShipmentContainerPicturesBeforeDestuffing(e.target.files), handleBeforeDestuffingChange(e)]} 
                    multiple
              />
            </div>

            <div className="row">
              {shipmentContainerPicturesBeforeDestuffingPreview?.map((item, index) => (
                <div className="col-6 mt-3" key={index}>
                  <img
                    src={item.preview}
                    alt="preview"
                    className="img-fluid rounded border"
                    style={{ height: 150, objectFit: "cover", width: "100%" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerBeforeDestuffingModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerBeforeDestuffing(e)}>
                {shipmentContainerBeforeDestuffingLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Upload"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/*  --------------------------- Upload Container Pics After De-Stuffing --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerAfterDestuffingModal} onHide={() => handleCloseShipmentContainerAfterDestuffingModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Container Pictures Before Stuffing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div class="form-group">
              <label for="before_stuffing_pictures" class="col-12 font-12px text-left mb-2">Upload Pictures</label>
              <input type="file" 
                    className="form-control" 
                    name="before_stuffing_pictures" 
                    id="before_stuffing_pictures"
                     accept="image/jpeg,image/jpg,image/png"
                    onChange={(e) => [setShipmentContainerPicturesAfterDestuffing(e.target.files), handleAfterDestuffingChange(e)]} 
                    multiple
              />
            </div>

            <div className="row">
              {shipmentContainerPicturesAfterDestuffingPreview?.map((item, index) => (
                <div className="col-6 mt-3" key={index}>
                  <img
                    src={item.preview}
                    alt="preview"
                    className="img-fluid rounded border"
                    style={{ height: 150, objectFit: "cover", width: "100%" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerAfterDestuffingModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => containerAfterDestuffing(e)}>
                {shipmentContainerAfterDestuffingLoader ?
                <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                "Upload"
              }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>



      {/*  --------------------------- View Container Pics --------------------------- */}
      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)'  }} show={showShipmentContainerPicsModal} onHide={() => handleCloseShipmentContainerPicsModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Container Pictures</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-3">
              <p className="text-center">BEFORE STUFFING</p>
              {shipmentContainerPictureDataPending ? (
                <div className="text-center mt-5">
                  <div className="spinner-border text-muted my-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : shipmentContainerPictureData &&
                shipmentContainerPictureData.filter(p => p.picture_category === "BEFORE_STUFFING").length > 0 ? (
                  shipmentContainerPictureData
                    .filter(p => p.picture_category === "BEFORE_STUFFING")
                    .map(picture => (
                      <div className="col-12 mb-2" key={picture.id}>
                        <a href={picture.picture} target="_blank">
                          <img
                            src={picture.picture}
                            className="img img-thumbnail w-100"
                            alt="Before stuffing"
                            style={{ height: 200, objectFit: "cover" }}
                          />
                        </a>
                      </div>
                    ))
              ) : (
                <p className="text-muted text-center" style={{ marginTop: 100 }}>No Images Found</p>
              )}
            </div>

            <div className="col-3">
              <p className="text-center">AFTER STUFFING</p>
              {shipmentContainerPictureDataPending ? (
                <div className="text-center mt-5">
                  <div className="spinner-border text-muted my-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : shipmentContainerPictureData &&
                shipmentContainerPictureData.filter(p => p.picture_category === "AFTER_STUFFING").length > 0 ? (
                  shipmentContainerPictureData
                    .filter(p => p.picture_category === "AFTER_STUFFING")
                    .map(picture => (
                      <div className="col-12 mb-2" key={picture.id}>
                        <a href={picture.picture} target="_blank">
                          <img
                            src={picture.picture}
                            className="img img-thumbnail w-100"
                            alt="Before stuffing"
                            style={{ height: 200, objectFit: "cover" }}
                          />
                        </a>
                      </div>
                    ))
              ) : (
                <p className="text-muted text-center" style={{ marginTop: 100 }}>No Images Found</p>
              )}
            </div>

            <div className="col-3">
              <p className="text-center">BEFORE DE-STUFFING</p>
              {shipmentContainerPictureDataPending ? (
                <div className="text-center mt-5">
                  <div className="spinner-border text-muted my-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : shipmentContainerPictureData &&
                shipmentContainerPictureData.filter(p => p.picture_category === "BEFORE_DESTUFFING").length > 0 ? (
                  shipmentContainerPictureData
                    .filter(p => p.picture_category === "BEFORE_DESTUFFING")
                    .map(picture => (
                      <div className="col-12 mb-2" key={picture.id}>
                        <a href={picture.picture} target="_blank">
                          <img
                            src={picture.picture}
                            className="img img-thumbnail w-100"
                            alt="Before stuffing"
                            style={{ height: 200, objectFit: "cover" }}
                          />
                        </a>
                      </div>
                    ))
              ) : (
                <p className="text-muted text-center" style={{ marginTop: 100 }}>No Images Found</p>
              )}
            </div>

            <div className="col-3">
              <p className="text-center">AFTER DE-STUFFING</p>
              {shipmentContainerPictureDataPending ? (
                <div className="text-center mt-5">
                  <div className="spinner-border text-muted my-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : shipmentContainerPictureData &&
                shipmentContainerPictureData.filter(p => p.picture_category === "AFTER_DESTUFFING").length > 0 ? (
                  shipmentContainerPictureData
                    .filter(p => p.picture_category === "AFTER_DESTUFFING")
                    .map(picture => (
                      <div className="col-12 mb-2" key={picture.id}>
                        <a href={picture.picture} target="_blank">
                          <img
                            src={picture.picture}
                            className="img img-thumbnail w-100"
                            alt="Before stuffing"
                            style={{ height: 200, objectFit: "cover" }}
                          />
                        </a>
                      </div>
                    ))
              ) : (
                <p className="text-muted text-center" style={{ marginTop: 100 }}>No Images Found</p>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseShipmentContainerPicsModal()}>Close</Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PlannedExportContainer;
